import { useDispatch, useSelector } from "react-redux";
import email from "../Static Files/Images/contact/Email 128x128.png";
import pin from "../Static Files/Images/contact/Pin 128x128.png";
import phone from "../Static Files/Images/contact/Telephone 128x128.png";
import "../Static Files/styles/contact/contact.css";
import { useState } from "react";
import { addRequest } from "../slices/contactSlice";
import Success from "../Components/success";
import { useLocation } from "react-router-dom";
import translation from "../locales";

const Contact = () => {
  const dispatch = useDispatch();
  const [isSuccess, setIsSuccess] = useState(false);
  const { status } = useSelector((state) => state.contacts);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phonenumber: "",
    subject: "",
    message: "",
  });
  const location = useLocation();

  const lang = location.pathname.split("/")[1];
  const currentLang = translation[lang] ? lang : "az";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(addRequest(formData));
    formData.name = "";
    formData.email = "";
    formData.phonenumber = "";
    formData.subject = "";
    formData.message = "";
    if (status === "succeeded") {
      setIsSuccess(true);
    }
  };
  return (
    <>
      <main>
        <section className="info-section">
          <div className="contact-info">
            <div className="header">
              <h3>{translation[currentLang].contactinfoh3}</h3>
              <h1>{translation[currentLang].contactinfoh1}</h1>
              <p dangerouslySetInnerHTML={{
                __html: translation[currentLang].contactinfop,
              }}>
              </p>
            </div>
            <div className="card-div">
              <div>
                <img src={email} alt="mail" />
                <h2>{translation[currentLang].contactinfocard1h2}</h2>
              </div>
              <p>{translation[currentLang].contactinfocard1p}</p>
              <h4>info@joyfultravel.az</h4>
            </div>
            <div className="card-div">
              <div>
                <img src={pin} alt="pin" />
                <h2>{translation[currentLang].contactinfocard2h2}</h2>
              </div>
              <p>{translation[currentLang].contactinfocard2p}</p>
              <h4>info@joyfultravel.az</h4>
            </div>
            <div className="card-div">
              <div>
                <img src={phone} alt="phone" />
                <h2>{translation[currentLang].contactinfocard3h2}</h2>
              </div>
              <p>{translation[currentLang].contactinfocard3p}</p>
              <h4>(+99455) 507 44 99</h4>
            </div>
          </div>
          <div className="comment-form">
            <h1>{translation[currentLang].contactinfoform}</h1>
            <form onSubmit={handleSubmit}>
              <div className="inputs-1">
                <input
                  value={formData.name}
                  onChange={handleChange}
                  name="name"
                  className="textbox"
                  type="text"
                  placeholder={translation[currentLang].contactinfoformname}
                />
                <input
                  value={formData.email}
                  onChange={handleChange}
                  className="textbox"
                  name="email"
                  type="text"
                  placeholder={translation[currentLang].contactinfoformemail}
                />
              </div>
              <div className="inputs-2">
                <input
                  value={formData.phonenumber}
                  onChange={handleChange}
                  name="phonenumber"
                  className="textbox"
                  type="text"
                  placeholder={translation[currentLang].contactinfoformphone}
                />
                <input
                  value={formData.subject}
                  name="subject"
                  onChange={handleChange}
                  className="textbox"
                  type="text"
                  placeholder={translation[currentLang].contactinfoformsubject}
                />
              </div>
              <div className="text-area">
                <textarea
                  value={formData.message}
                  name="message"
                  onChange={handleChange}
                  placeholder={translation[currentLang].contactinfowritehere}
                />
              </div>
              {isSuccess && <h3 style={{fontSize:"1vw",color:"#16C47F"}}>Mesajınız uğurla göndərildi təşəkkür edirik!</h3>}
              <button type="submit">{status === "loading" ? "Göndərilir..." : "Göndər"}</button> 
            </form>
          </div>
        </section>

        <section className="map-section">
          <div>
            <h3>{translation[currentLang].contactinfomap}</h3>
            <h1>{translation[currentLang].contactinfolocation}</h1>
          </div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.907384274297!2d49.86624717496315!3d40.41090247144046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307df49a496f3d%3A0xae92fe437959bf!2sJOYFUL%20TRAVEL%20LLC!5e0!3m2!1saz!2saz!4v1739737240815!5m2!1saz!2saz"
            width="100%"
            height="500vw"
            style={{ border: "none" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </section>

      </main>
    </>
  );
};

export default Contact;
